// Public legal page (no auth gate). Linked from the subscription
// activation flow and from the consent checkbox. Plain typography, no app
// chrome — keep the URL stable so accepted-version timestamps in
// Firestore stay meaningful even if the page moves later.

export function SubscriptionTerms() {
  return (
    <div className="min-h-screen bg-bg">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-black text-ink mb-2">
          Términos de la suscripción
        </h1>
        <p className="text-sm text-ink-3 mb-10">
          Versión <strong>v1</strong> · Actualizado: 2026-04-27
        </p>

        <Section title="1. Objeto del servicio">
          Cowboy ofrece acceso a su API y al panel de gestión asociado bajo
          un modelo de suscripción mensual con asientos (seats). Cada plan
          (en adelante, &laquo;tier&raquo;) define cuotas mensuales, límite
          de almacenamiento, límite de peticiones por minuto y un precio
          por seat. La asignación de seats y de plan a cada organización
          la realiza el equipo de Cowboy con el conocimiento del Cliente.
        </Section>

        <Section title="2. Precio y facturación">
          El precio por seat de cada tier figura en el panel del Cliente y
          en la documentación pública en el momento de la contratación.
          Las cantidades se expresan en euros (EUR) y, salvo que se
          indique lo contrario, no incluyen impuestos repercutibles, que
          se aplicarán según la legislación vigente. La facturación se
          emite mensualmente a través de Stripe Payments Europe, Ltd. en
          la fecha de inicio del ciclo, por adelantado.
        </Section>

        <Section title="3. Variabilidad del precio">
          Cowboy podrá revisar el precio de cualquier tier. Cualquier
          cambio se comunicará al email del propietario (owner) de la
          organización con una antelación mínima de <strong>siete (7)
          días naturales</strong> respecto a la siguiente fecha de
          facturación. Los cambios solo se aplicarán al{" "}
          <strong>próximo ciclo</strong> y nunca al ciclo ya facturado o
          en curso. El Cliente podrá cancelar la suscripción antes del
          siguiente cargo sin coste ni penalización (ver sección 5). La
          continuidad del servicio tras la fecha indicada se entenderá
          como aceptación tácita del nuevo precio.
        </Section>

        <Section title="4. Duración y renovación">
          La suscripción se contrata por periodos mensuales y se renueva
          de forma automática al inicio de cada ciclo, salvo cancelación
          previa. Los cambios de seats (incrementos) se prorratean en el
          ciclo en curso conforme a la política de prorrateo de Stripe;
          las reducciones de seats se aplican al final del ciclo en curso.
        </Section>

        <Section title="5. Cancelación">
          El Cliente podrá cancelar la suscripción en cualquier momento
          desde el panel (sección &laquo;API · Subscription&raquo;) o
          desde el portal de facturación de Stripe. La cancelación es
          efectiva al final del ciclo en curso. Cowboy no realiza
          reembolsos de cargos ya emitidos salvo que la legislación
          aplicable lo exija.
        </Section>

        <Section title="6. Datos personales y privacidad">
          El tratamiento de datos personales se rige por la Política de
          Privacidad. Cowboy actúa como encargado del tratamiento respecto
          de los datos que el Cliente introduce en la plataforma y como
          responsable respecto de los datos de la cuenta del Cliente.
        </Section>

        <Section title="7. Modificación de los términos">
          Cowboy podrá actualizar estos términos. La versión vigente
          quedará identificada por su número (v1, v2, etc.) y por la
          fecha indicada en la cabecera. Los cambios sustanciales se
          comunicarán por email con al menos siete (7) días naturales de
          antelación. La aceptación previa permanecerá vigente para los
          aspectos no modificados.
        </Section>

        <Section title="8. Ley aplicable y jurisdicción">
          Estos términos se rigen por la legislación española. Cualquier
          controversia derivada de su interpretación o ejecución se
          someterá a los Juzgados y Tribunales del domicilio del Cliente,
          cuando éste sea consumidor; en otro caso, a los Juzgados y
          Tribunales de Madrid (España), salvo norma imperativa en
          contrario.
        </Section>

        <p className="text-xs text-ink-3 mt-12">
          Para cualquier consulta sobre estos términos puedes escribir a{" "}
          <a
            href="mailto:hello@cowboys.so"
            className="underline text-ink-2 hover:text-ink"
          >
            hello@cowboys.so
          </a>
          .
        </p>
      </div>
    </div>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="mb-8">
      <h2 className="text-base font-black text-ink mb-2">{title}</h2>
      <p className="text-sm leading-relaxed text-ink-2">{children}</p>
    </section>
  );
}
